// i need a function that format the value to be more readable
// ineed both us and indian number format

// for example 123456987 to 123,456,987
// for example 123456987 to 12,34,56,987

const valueFormator = (value, system = "US", options = {}) => {
  const toNum = (v) => {
    if (typeof v === "number") return v;
    if (typeof v === "string") {
      const cleaned = v.replace(/,/g, "").trim();
      const n = Number(cleaned);
      return n;
    }
    return NaN;
  };

  const n = toNum(value);
  if (!isFinite(n)) return value;

  const s = String(system).toLowerCase();
  const locale =
    s === "in" || s === "indian" || s === "en-in" ? "en-IN" : "en-US";

  const { decimals, format } = options;
  let opts;
  if (decimals != null && isFinite(decimals)) {
    const d = Math.max(0, Math.floor(decimals));
    opts = { minimumFractionDigits: d, maximumFractionDigits: d };
  }

  if (String(format || "").toLowerCase() === "compact") {
    opts = {
      ...(opts || {}),
      notation: "compact",
    };
  }

  return new Intl.NumberFormat(locale, opts).format(n);
};

export { valueFormator };
